<template>
  <div class="basic_wrap">
    <!-- <div class="login_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{$t('login.login')}}</div>
			<div class="language" @click="$router.push('/language')">
				<img :src="require('../images/language/'+lang+'.png')">
			</div>
        </div> -->
    <div class="lan-box">
      <van-popover v-model="showPopover" trigger="click" placement="bottom-start" :offset="[0, 0]" :actions="actions"
        @select="onSelect">
        <template #reference>
          <div class="lan-label">
            <img :src="lan_ico" alt="">
            <span>{{ lan_num }}</span>
          </div>
        </template>
      </van-popover>
    </div>
    <div class="user-top">
      <img src="../images/login/Snipaste2.png" alt="">
      <div class="user-name">
        国家开发银行
      </div>
      <div class="palace-welcome">推进精准扶贫 打赢脱贫攻坚战</div>
      <div class="bottom-size">国开行走出开发性金融脱贫攻坚新路子</div>
    </div>
    <!-- <div class="user-contain">
      <img
        src="../images/login/wudi2.png"
        alt=""
      >
    </div> -->
    <div class="login-main">
      <form class="form">
        <div class="cut_login" style="display: none;">
          <router-link class="cur" to="/login">
            {{ $t('login.signIn') }}
            <div class="line" />
          </router-link>
          <router-link to="/register">
            {{ $t('login.signUp') }}
            <div class="line" />
          </router-link>
        </div>
        <div class="cut_login" style="color: #e50113;">{{ $t('login.signIn') }}</div>
        <div class="item mt" style="padding-left: 10px;">
          <span class="icon"><img src="../images/login/email.png" alt=""></span>
          <input v-model.trim="data.username" type="text" class="inp" placeholder="请输入手机号码">
        </div>

        <div class="item" style="padding-left: 10px;">
          <span class="icon"><img src="../images/login/lock.png" alt=""></span>
          <input v-model.trim="data.password" :type="password" class="inp" :placeholder="$t('login.password')">
          <div class="eye_bi" :class="password == 'text' ? 'eye' : ''" @click="showPwd" />
        </div>

        <div class="item_reset_pwd">
          <van-checkbox v-model="checked" shape="square" icon-size="14px">
            {{ $t('login.remember') }}
          </van-checkbox>
          <div class="reset_pwd" @click.stop="kefu_to">
            {{ $t('login.forget') }}
          </div>
        </div>
        <div type="submit" class="basic_btn sbtn" :class="data.username == '' || data.password == '' ? 'no_touch' : ''
          " @click="submit">
          {{ $t('login.signInBtn') }}
        </div>
        <div style="text-align: center;">还没有账号?<router-link to="/register" style="color: #e50113;">
            立即注册
            <div class="line" />
          </router-link></div>
      </form>
    </div>
    <div class="btns-grounp">
      <div v-if="msg_show" class="kefu-link" :class="show_kefu ? '' : 'kefu_hide'" @click="kefu_to">
        <img class="kefu_img" src="../images/new/kefu2.jpg">
        在线客服
      </div>
      <div v-if="msg_show" class="kefu-link" :class="show_kefu ? '' : 'kefu_hide'" @click="downloads">
        <img class="kefu_img" src="../images/new/download2.jpg">
        APP下载
      </div>
    </div>

    <!-- <van-dialog v-model="show_ver" theme="round-button" :confirm-button-text="$t('utils.confirm')"
      :cancel-button-text="$t('utils.cancel')" @confirm="confirm">
      <div class="show-body">
        {{ $t('您认证邮箱后再投资！') }}
      </div>
    </van-dialog> -->
  </div>
</template>

<script>
import Vue from 'vue'
import Fetch from "../../utils/fetch"
import { CountDown, Checkbox, Popover } from 'vant'
Vue.use(Checkbox)
Vue.use(Popover)

export default {
  name: "Login",
  data() {
    return {
      lang: this.$i18n.locale || "zh_cn",
      password: "password",
      show_kefu: false,
      msg_show: true,
      checked: true,
      showPopover: false,
      actions: [
        { text: '中国', icon: require('../images/language/zh_cn.png'), },
        { text: 'English', icon: require('../images/language/en_us.png'), },
        { text: '日本', icon: require('../images/language/ja_jp.png'), },
        { text: 'Brasil', icon: require('../images/language/ko_kr.png'), },
        { text: 'Việt Nam', icon: require('../images/language/vi_vn.png'), },
        { text: 'Malaysia', icon: require('../images/language/th_th.png'), },
        { text: 'ประเทศไทย', icon: require('../images/language/ms_my.png'), },
        { text: 'Indonesia', icon: require('../images/language/zh_hk.png'), },
      ],
      lan_num: '中国',
      lan_ico: require('../images/language/zh_cn.png'),
      data: {
        username: "",
        password: "",
      },
      show_ver: false,
    };
  },
  created() {
    this.data.username = localStorage.getItem('login_username');
    this.data.password = localStorage.getItem('login_password');
    this.$parent.footer("user", false);
  },
  mounted() {
    var that = this;
    document.body.addEventListener(
      "scroll",
      function () {
        if (!that.show_kefu) {
          return;
        }
        that.show_kefu = false;
      },
      false
    );
    document.addEventListener(
      "click",
      function (ev) {
        if (ev.target.className != "kefu_img") {
          that.show_kefu = false;
        }
      },
      false
    );
  },
  methods: {
    kefu_to() {
      // this.$router.push("/kefu");
      Fetch('/user/system_info').then((r) => {
         window.location.href = r.data.service
					// window.open(r.data.service, '_blank');
				});
      // if (this.show_kefu) {
      //   this.$router.push("/kefu");
      // }
      // this.show_kefu = !this.show_kefu;
    },
    downloads() {
      this.$router.push("/downloadApp");
    },

    showPwd() {
      if (this.password == "password") {
        this.password = "text";
      } else {
        this.password = "password";
      }
    },
    onSelect(action) {
      console.log(action)
      this.lan_ico = action.icon
      this.lan_num = action.text
      let lang
      if (action.text == "中国") {
        lang = "zh_cn"
      }
      if (action.text == "English") {
        lang = "en_us"
      }
      if (action.text == "日本") {
        lang = "ja_jp"
      }
      if (action.text == "Brasil") {
        lang = "ko_kr"
      }
      if (action.text == "Việt Nam") {
        lang = "vi_vn"
      }
      if (action.text == "Malaysia") {
        lang = "th_th"
      }
      if (action.text == "ประเทศไทย") {
        lang = "ms_my"
      }
      if (action.text == "Indonesia") {
        lang = "zh_hk"
      }
      this.$i18n.locale = lang;
      localStorage.setItem("lang", lang);
    },
    submit() {
      if (!this.data.username) {
        this.$toast({
          className: "toastName",
          message: this.$t('login.phoneEmpty'),
        });
        return;
      }

      if (!this.data.password) {
        this.$toast({
          className: "toastName",
          message: this.$t('login.passwordEmpty'),
        });
        return;
      }

      // var regex = /^[A-Za-z0-9]{1,20}$/;
      // if (!regex.test(this.data.username)) {
      //     this.$toast(this.$t('login.phoneError'));
      //     return;
      // }

      if (this.checked) {
        localStorage.setItem('login_username', this.data.username);
        localStorage.setItem('login_password', this.data.password);
      }

      if (!this.checked) {
        localStorage.removeItem('login_username');
        localStorage.removeItem('login_password');
      }

      Fetch("/index/login", {
        username: this.data.username,
        password: this.data.password
      })
        .then((res) => {
          if (res.data.token) {
            localStorage.setItem('token', res.data.token);
          }
          this.$toast({
            className: "toastName",
            message: this.$t('login.signInSuccess'),
          });
        })
        .then(() => {
          this.$router.replace({
            path:
              this.$router.history.current.query.redirect || "/",
          });
        });
    },
  },
};
</script>

<style lang="less" scoped>
.user-top {
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  padding: 90px 0 10px 0;
  color: #ffffff;

  img {
    width: 60px;
    height: 60px;
    border-radius: 5px;
    // border: 2px solid #ffffff;
  }

  .user-name {
    font-size: 36px;
    margin: 20px 0;
    background-color: #e50113;
    background-clip: text;
    color: transparent;
    font-weight: bold;
  }
}

.basic_wrap {
  position: relative;
  background: url(../images/user/8b4.jpg) no-repeat center;
  background-size: 112% 102%;
  height: 100vh;

  .lan-box {
    display: none;
    position: absolute;
    top: 10px;
    left: 25px;
  }
}


.login_bg {
  width: 100%;
  overflow: hidden;

  .language {
    position: absolute;
    top: 4px;
    right: 0;
    height: 36px;

    img {
      height: 100%;
    }
  }
}

.login-main {
  padding: 0 25px;
}

.basic_wrap .form {
  // background: rgba(255, 255, 255, 1);
  // box-shadow: 0px 4px 9px 2px rgba(160, 160, 160, 0.15);
  // border-radius: 13px;
  padding: 31px 24px 24px 24px;
}

.cut_login {
  width: 207px;
  line-height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  text-align: center;
  margin: 0 auto;

  a {
    width: 50%;
    padding-bottom: 10px;
    color: #ceced0;
    position: relative;

    .line {
      width: 100%;
      height: 1px;
      position: absolute;
      left: 0;
      bottom: 0;
      background-color: #f2f2f2;
    }
  }

  a.cur {
    color: #f12211;

    .line {
      height: 2px;
      background-image: linear-gradient(to right, #f12211, #f18a11);
    }
  }
}

.mt {
  margin-top: 20px;
}

.item {
  background-color: #e9e9e9;
  height: 48px;
  padding: 0 15px;
  // border: 1px solid #dfdfdf;
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 15px;

  .icon {
    width: 20px;
    min-width: 20px;
    text-align: center;
    height: 20px;

    img {
      width: 20px;
      height: 20px;
    }
  }

  input {
    height: 20px;
    margin-left: 7px;
    flex: 1;
  }
}

.item_reset_pwd {
  font-size: 14px;
  color: #3d96ff;
  text-align: right;
  margin-top: 10px;
  line-height: 20px;
}

.van-checkbox {
  margin-top: 20px;
}

/deep/ .van-checkbox__icon--checked .van-icon {
  color: #fff;
  background-color: #ff5a50;
  border-color: #ff5a50;
}

/deep/ .van-checkbox__label {
  color: #ff5a50;
}

.reset_pwd {
  color: #333;
  margin-top: -20px;
  display: block;
}

.basic_btn {
  margin: 20px auto 20px auto;
  width: 100% !important;
  border-radius: 0px !important;
}

.lan-label {
  display: flex;
  align-items: center;
  white-space: nowrap;
  height: 48px;
  min-width: 24px;
  height: 25px;
  padding-right: 8px;
  border-radius: 25px;
  background-image: linear-gradient(to right, #ffff80, #ffffff);
}

.lan-label span {
  display: inline-block;
  margin-left: 3px;
}

.lan-label img {
  width: 22px;
  height: 22px;
}

.btns-grounp {
  display: flex;
  gap: 13px;
  justify-content: center;
}

.kefu-link {
  // padding: 20px;
  text-align: center;
  background: linear-gradient(90deg, #FFE4B0 0%, #FFD18C 100%);
  gap: 8px;
  width: 30%;
  display: flex;
  align-items: center;
  border-radius: 5px;
  height: 40px;
  justify-content: center;
  height: 33px;
  font-size: 12px;
  color: black;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.kefu-link img {
  border-radius: 10px;
  width: 20px;
  height: 20px;
}

.show-body {
  padding: 30px 30px 15px 30px;
  text-align: center;
}
</style>
<style>
.van-popover {
  width: 120px;
}

.van-popover__action {
  height: 40px;
  line-height: 40px;
}

.van-popover .van-popover__action-text::after {
  left: -100px;
}

.van-popover__action-icon {
  border: 1px solid #ececec;
  border-radius: 30px;
}

.van-popover__action {
  padding: 0 10px;
}


.palace-welcome {
  width: 300px;
  height: 50px;
  /* padding: 5px; */
  /* background: #9e2b27; */
  color: #e50113;
  border: 2px solid #e50113;
  border-radius: 5px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
  text-align: center;
  font-family: "楷体", "STKaiti", serif;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

.palace-welcome::before,
.palace-welcome::after {
  content: "★";
  color: #e50113;
  font-size: 15px;
  margin: 0 10px;
}

.palace-welcome::before {
  margin-right: 10px;
}

.palace-welcome::after {
  margin-left: 10px;
}

.bottom-size {
  margin: 10px 0;
  color: black;
  font-size: 15px;
}
</style>
